import { SocialMediaFacebookPreviewController } from './social-media-facebook-preview.controller'

function socialMediaFacebookPreview () {
  return {
    restrict: 'E',
    controller: SocialMediaFacebookPreviewController,
    templateUrl: '/arts/directives/social-media-facebook-preview/social-media-facebook-preview.html?$$REVISION$$',
    scope: {
      previewType: '<',
      imageUrl: '<',
      caption: '<'
    }
  }
}

export { socialMediaFacebookPreview }
